// Query-keys factory for the owner onboarding wizard.
//
// Nothing in a key identifies the owner — no invite token, no session token, no
// owner id. One browser tab serves exactly one owner (the session pins which),
// so a per-owner key would buy nothing and would put a live credential into the
// cache key, where the query devtools render it.
export const ownerOnboardingKeys = {
  all: ['ownerOnboarding'] as const,
  context: () => [...ownerOnboardingKeys.all, 'context'] as const,
  kycStatus: () => [...ownerOnboardingKeys.all, 'kycStatus'] as const,
  countries: () => [...ownerOnboardingKeys.all, 'countries'] as const,
  bankAccount: () => [...ownerOnboardingKeys.all, 'bankAccount'] as const,
  // Seller-portal entry. Keyed by request — unlike the wizard keys, this read is
  // scoped by the seller's JWT, not a session, and differs per request.
  sellerAvailability: (listingRequestId: string) =>
    [...ownerOnboardingKeys.all, 'sellerAvailability', listingRequestId] as const,
}
